import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import type { HTMLAttributes, ReactNode } from 'react';
import styles from './Prose.module.scss';
export type ProseAlign = 'start' | 'center';
export type ProseSize = 'compact' | 'default' | 'article';
export interface ProseProps extends Omit<HTMLAttributes<HTMLDivElement>, 'className' | 'style'> {
  align?: ProseAlign;
  children: ReactNode;
  size?: ProseSize;
}
function Prose(t0) {
  const $ = _c(13);
  let children;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      align: t1,
      children,
      size: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
  } else {
    children = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const align = t1 === undefined ? "start" : t1;
  const size = t2 === undefined ? "default" : t2;
  const t3 = styles[`helios-prose--align-${align}`];
  const t4 = styles[`helios-prose--size-${size}`];
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = classNames(styles["helios-prose"], t3, t4);
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== children || $[9] !== props || $[10] !== size || $[11] !== t5) {
    t6 = <div {...props} className={t5} data-helios-prose={size}>{children}</div>;
    $[8] = children;
    $[9] = props;
    $[10] = size;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
export default Prose;